<div
  [proffeoSpinner]="companyArchivedProjects() === undefined"
  proffeoSpinnerSize="lg"
  class="min-h-48 w-full"
>
  @if (companyArchivedProjects()?.length === 0) {
    <div class="flex w-full items-center justify-center p-4">
      <p>{{ 'placeholders.no-results-found' | translate }}</p>
    </div>
  } @else if (companyArchivedProjects(); as projects) {
    @for (project of projects; track project?.id) {
      <proffeo-company-project-item
        (restoreProject)="restoreProject($event)"
        (deleteProject)="openProjectTagDeleteConfirmationDialog($event)"
        [project]="project"
        [isArchivedProject]="true"
      ></proffeo-company-project-item>
    }
  }
</div>
